export const BRANDS_SET_BRANDS = 'BRANDS_SET_BRANDS'
export const BRANDS_SET_OPTIMISTIC_BRAND_UPDATE = 'BRANDS_SET_OPTIMISTIC_BRAND_UPDATE'
